// @flow

import borderImage from '../images/border.png'

export const styles = {
  container: {
    height: '100vh',
    minHeight: 450,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    '@media (max-width: 767px)': {
      height: 'unset'
    }
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& p': {
      fontSize: 24,
      fontFamily: 'TTNorms-Regular',
      lineHeight: '36px',
      marginBottom: 43
    },
    '& strong': {
      fontFamily: 'TTNorms-Bold'
    },
    '& > img': {
      marginTop: 60,
      marginLeft: -11,
      width: 75
    },
    '@media (max-width: 767px)': {
      marginTop: 60,
      marginBottom: 20
    }
  },
  button: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 190,
    height: 34,
    padding: '2px 0 2px 0',
    marginRight: 20,
    marginBottom: 20,
    border: '2px solid #1F1F1F',
    borderRadius: 4,
    textDecoration: 'none',
    textAlign: 'center',
    color: '#1F1F1F',
    fontSize: 16,
    '&:hover': {
      backgroundColor: '#1F1F1F',
      color: 'white'
    }
  },
  link: {
    display: 'inline-block',
    padding: '2px 0 2px 0',
    color: '#1F1F1F',
    fontSize: 16
  },
  notes: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 40,
    marginBottom: 10,
    '& > a': {
      marginRight: 20
    }
  },
  borderTop: {
    display: 'inline-block',
    borderTop: '1px solid rgba(0,0,0,.3)',
    paddingTop: 7
  },
  linkParagraph: {
    width: 190,
    textDecoration: 'none',
    color: '#1F1F1F',
    fontSize: 12,
    lineHeight: '15px',
    '& strong': {
      fontFamily: 'TTNorms-Bold',
      '&:before': {
        content: '" "',
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: '100%',
        marginRight: 4,
        backgroundColor: '#1F1F1F'
      }
    }
  },
  available: {
    '& strong': {
      color: '#2AB053',
      '&:before': {
        backgroundColor: '#2AB053'
      }
    }
  },
  unavailable: {
    '& strong': {
      color: '#EF6060',
      '&:before': {
        backgroundColor: '#EF6060'
      }
    }
  },
  socialMedias: {
    width: 190,
    color: '#1F1F1F',
    fontSize: 12,
    lineHeight: '15px',
    '& > p': {
      marginBottom: 8
    },
    '& a': {
      display: 'inline-block',
      fontSize: 18,
      color: '#1F1F1F',
      textDecoration: 'none',
      margin: '0 16px 0 0',
      '&:last-child': {
        marginRight: 0
      },
      '& > .icn-medium:hover': {
        color: '#02B875'
      },
      '& > .icn-dribbble:hover': {
        color: '#EC4A89'
      },
      '& > .icn-linkedin:hover': {
        color: '#0077B5'
      }
    }
  },
  canvas: {
    height: '100vh',
    padding: 0,
    backgroundColor: '#F2F2F2',
    border: 0,
    borderLeft: '4px solid transparent',
    borderImage: 'url(' + borderImage + ') 0% 10 repeat'
  },
  paddingRight0: {
    paddingRight: 0
  },
  marginLeftNeg90: {
    marginLeft: -90
  }
}



// WEBPACK FOOTER //
// ./src/Styles/index.Style.js